import styled from "styled-components"

export const Container = styled.div`
  .products-container {
    max-width: 100%;
    margin: 0 auto;
    justify-content: space-between;
    align-items: center;
    border-radius: 10px;
    width: 90%;
    margin: auto;
    padding-top: 120px;
    min-width: 60%;
    max-width: 30%;
    position: relative;
  }

  button {
    background: #4169e1;
    border-radius: 5px;
    color: white;
  }

  h4,
  p {
    font-size: 80%;
  }

  @media screen and (min-width: 750px) {
    .products-container {
      display: grid;
      grid-template-columns: repeat(1, 2fr);
      grid-gap: 15px;
      list-style: none;
      align-items: center;
      width: 100%;
      padding-top: 100px;

      float: left;
      padding-left: 19%;
    }
  }
`
